export default __webpack_public_path__ + "static/media/mec-2.edea5954.png";